"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HeaderMore',
  props: {
    title: {
      type: String,
      default: ''
    },
    noMore: {
      type: Boolean,
      default: false
    },
    noTitle: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    clickMoreBtn: function clickMoreBtn() {
      this.$emit('more');
    }
  }
};